import * as React from "react";
import * as Scrivito from "scrivito";
import { HelmetProvider } from "react-helmet-async";
import "@farfalla/shared/assets/styles/variables.css";
import "@farfalla/shared/assets/webfonts/webfonts.css";
import "@farfalla/shared/assets/icons/icons.css";

export const helmetContext = {};

export function App({ appWrapperRef }) {
  return (
    <HelmetProvider context={helmetContext}>
      <div ref={appWrapperRef}>
        <div className="content-wrapper">
          <div id="mainContent">
            <Scrivito.CurrentPage />
          </div>
          <Scrivito.NotFoundErrorPage></Scrivito.NotFoundErrorPage>
        </div>
      </div>
    </HelmetProvider>
  );
}
